__turbopack_context__.v({
  "selectedText": "-rAJNG_selectedText",
});
